import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { I } from "../../Components/CMI/icons";
import { Card, Badge } from "../../Components/CMI/primitives";
import PageHead, { Footer } from "../../Layouts/CMI/PageHead";
import { getCmiEmpresas, getCmiEmpresa, createCmiEmpresa, updateCmiEmpresa, deleteCmiEmpresa, getErpEmpresas, getPresupuestosPorEmpresa, createPresupuesto, getCuentasContables, getCategoriasCuentas, clasificarCuenta, desclasificarCuenta, syncCuentasHolded, getEmpleados, vincularEmpleado, toggleEmpleado, deleteEmpleado, getCategoriasEmpleados, saveCategoriasEmpleados, getUsuariosErp, getKronalyEmpleados, getBenchmarks, saveBenchmarks } from "../../helpers/configApi";

const sections = [
  { id: "empresas",  label: "Empresas",               icon: I.Building },
  { id: "empleados", label: "Empleados",              icon: I.Users },
  { id: "cuentas",   label: "Cuentas contables",      icon: I.FileText },
  { id: "presup",    label: "Presupuestos",            icon: I.Coin },
  { id: "bench",     label: "Benchmarks",              icon: I.Target },
  { id: "conex",     label: "Conexiones",              icon: I.Plug },
  { id: "perfil",    label: "Perfil",                  icon: I.User },
  { id: "cuenta",    label: "Cuenta y seguridad",      icon: I.Shield },
  { id: "notif",     label: "Notificaciones",          icon: I.Bell },
  { id: "prefs",     label: "Preferencias",            icon: I.Settings },
];

const SettingCard = ({ icon: Ico, title, sub, children, foot, actions }) => (
  <Card>
    <div style={{ padding: "20px 24px 0", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
      <div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {Ico ? <Ico size={18} style={{ color: "var(--ce-fg-muted)" }} /> : null}
          <h3 style={{ margin: 0, fontFamily: "var(--ce-font-display)", fontSize: 16, fontWeight: 600, color: "var(--ce-fg)", letterSpacing: "-0.01em" }}>{title}</h3>
        </div>
        {sub ? <div style={{ marginTop: 6, color: "var(--ce-fg-muted)", fontSize: 13 }}>{sub}</div> : null}
      </div>
      {actions || null}
    </div>
    <div style={{ padding: "18px 24px 20px" }}>{children}</div>
    {foot ? <div className="cd-foot">{foot}</div> : null}
  </Card>
);

const Placeholder = ({ title }) => (
  <SettingCard icon={I.Info} title={title} sub="Esta sección está en construcción.">
    <div style={{ padding: 12, fontSize: 13, color: "var(--ce-fg-muted)" }}>
      Próximamente. Mientras tanto, los cambios se gestionan desde el ERP/CRM principal.
    </div>
  </SettingCard>
);

/* ══════════════════════════════
   Modal: Agregar empresa
   ══════════════════════════════ */
const ModalAgregarEmpresa = ({ onClose, onSave }) => {
  const [erpEmpresas, setErpEmpresas] = useState([]);
  const [loadingErp, setLoadingErp] = useState(true);
  const [selected, setSelected] = useState([]);
  const [nombre, setNombre] = useState("");
  const [holdedKey, setHoldedKey] = useState("");
  const [gscUrl, setGscUrl] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getErpEmpresas()
      .then(data => { setErpEmpresas(Array.isArray(data) ? data : []); setLoadingErp(false); })
      .catch(e => { console.error('[CMI] Error loading ERP empresas:', e); setLoadingErp(false); });
  }, []);

  const toggle = (id) => {
    setSelected(prev => {
      const next = prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id];
      if (!nombre || (prev.length > 0 && nombre === erpEmpresas.find(e => e.id === prev[0])?.NombreEmpresas)) {
        const first = erpEmpresas.find(e => e.id === (next[0] || id));
        if (first) setNombre(first.NombreEmpresas);
      }
      return next;
    });
  };

  const handleSave = async () => {
    if (!nombre.trim() || selected.length === 0) return;
    setSaving(true);
    try {
      await onSave({ nombre: nombre.trim(), empresas_erp_ids: selected, holded_api_key: holdedKey || undefined, gsc_site_url: gscUrl || undefined });
      onClose();
    } catch (e) {
      console.error(e);
      setSaving(false);
    }
  };

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.5)" }} onClick={onClose} />
      <div style={{ position: "relative", background: "var(--ce-surface)", borderRadius: 16, padding: 28, width: 540, maxHeight: "80vh", overflow: "auto", boxShadow: "var(--ce-shadow-xl)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
          <h3 style={{ margin: 0, fontSize: 18, fontWeight: 600, fontFamily: "var(--ce-font-display)" }}>Agregar empresa al CMI</h3>
          <button onClick={onClose} style={{ background: "none", border: 0, cursor: "pointer", color: "var(--ce-fg-muted)", padding: 4 }}>
            <I.X size={20} />
          </button>
        </div>

        {/* Paso 1: Seleccionar empresas del ERP */}
        <div style={{ marginBottom: 20 }}>
          <label style={{ fontSize: 12, fontWeight: 600, color: "var(--ce-fg-muted)", display: "block", marginBottom: 8 }}>
            Selecciona una o más empresas del ERP
          </label>
          <div style={{ border: "1px solid var(--ce-border)", borderRadius: 10, maxHeight: 200, overflow: "auto" }}>
            {loadingErp && (
              <div style={{ padding: 20, textAlign: "center", color: "var(--ce-fg-muted)", fontSize: 13 }}>
                Cargando empresas del ERP…
              </div>
            )}
            {!loadingErp && erpEmpresas.length === 0 && (
              <div style={{ padding: 20, textAlign: "center", color: "var(--ce-fg-muted)", fontSize: 13 }}>
                No se encontraron empresas en el ERP.
              </div>
            )}
            {erpEmpresas.map(emp => (
              <label key={emp.id}
                style={{
                  display: "flex", alignItems: "center", gap: 10, padding: "10px 14px",
                  borderBottom: "1px solid var(--ce-border-subtle)", cursor: "pointer",
                  background: selected.includes(emp.id) ? "var(--ce-primary-soft)" : "transparent",
                }}
              >
                <input type="checkbox" checked={selected.includes(emp.id)} onChange={() => toggle(emp.id)}
                  style={{ accentColor: "var(--ce-primary)" }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, color: "var(--ce-fg)" }}>{emp.NombreEmpresas}</div>
                  <div style={{ fontSize: 11, color: "var(--ce-fg-faint)" }}>
                    ID: {emp.id} · CIF: {emp.CifEmpresas}
                    {emp.tiene_holded ? " · Holded ✓" : ""}
                  </div>
                </div>
              </label>
            ))}
          </div>
          {selected.length > 1 && (
            <div style={{ marginTop: 6, fontSize: 11, color: "var(--ce-fg-muted)" }}>
              Se agregarán como empresa compuesta ({selected.length} empresas fusionadas)
            </div>
          )}
        </div>

        {/* Paso 2: Nombre editable */}
        <div style={{ marginBottom: 16 }}>
          <label style={{ fontSize: 12, fontWeight: 600, color: "var(--ce-fg-muted)", display: "block", marginBottom: 6 }}>
            Nombre en el cuadro de mando
          </label>
          <input
            value={nombre} onChange={e => setNombre(e.target.value)}
            placeholder="Ej: Visados Empresas"
            style={{
              width: "100%", padding: "8px 12px", borderRadius: 8,
              border: "1px solid var(--ce-border)", background: "var(--ce-bg)",
              color: "var(--ce-fg)", fontSize: 14, fontFamily: "var(--ce-font-sans)",
            }}
          />
        </div>

        {/* Paso 3: API key Holded (opcional) */}
        <div style={{ marginBottom: 16 }}>
          <label style={{ fontSize: 12, fontWeight: 600, color: "var(--ce-fg-muted)", display: "block", marginBottom: 6 }}>
            Holded API Key <span style={{ fontWeight: 400 }}>(opcional — se lee del ERP si existe)</span>
          </label>
          <input
            value={holdedKey} onChange={e => setHoldedKey(e.target.value)}
            placeholder="Solo si difiere del ERP"
            style={{
              width: "100%", padding: "8px 12px", borderRadius: 8,
              border: "1px solid var(--ce-border)", background: "var(--ce-bg)",
              color: "var(--ce-fg)", fontSize: 13, fontFamily: "var(--ce-font-mono)",
            }}
          />
        </div>

        {/* Botones */}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 24 }}>
          <button onClick={onClose}
            style={{ padding: "8px 20px", borderRadius: 8, border: "1px solid var(--ce-border)", background: "var(--ce-bg)", color: "var(--ce-fg)", cursor: "pointer", fontSize: 13 }}>
            Cancelar
          </button>
          <button onClick={handleSave} disabled={!nombre.trim() || selected.length === 0 || saving}
            style={{
              padding: "8px 20px", borderRadius: 8, border: 0, cursor: "pointer", fontSize: 13, fontWeight: 600,
              background: (!nombre.trim() || selected.length === 0) ? "var(--ce-bg-2)" : "var(--ce-primary)",
              color: (!nombre.trim() || selected.length === 0) ? "var(--ce-fg-muted)" : "#fff",
            }}>
            {saving ? "Guardando…" : "Agregar"}
          </button>
        </div>
      </div>
    </div>
  );
};

/* ══════════════════════════════
   Sección: Empresas
   ══════════════════════════════ */
const SectionEmpresas = () => {
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editNombre, setEditNombre] = useState("");

  const loadEmpresas = useCallback(async () => {
    try {
      const data = await getCmiEmpresas();
      setEmpresas(Array.isArray(data) ? data : []);
    } catch (e) { console.error(e); }
    setLoading(false);
  }, []);

  useEffect(() => { loadEmpresas(); }, [loadEmpresas]);

  const handleSave = async (data) => {
    await createCmiEmpresa(data);
    await loadEmpresas();
  };

  const handleDelete = async (id, nombre) => {
    if (!window.confirm(`¿Eliminar "${nombre}" del cuadro de mando?`)) return;
    await deleteCmiEmpresa(id);
    await loadEmpresas();
  };

  const handleRename = async (id) => {
    if (!editNombre.trim()) return;
    await updateCmiEmpresa(id, { nombre: editNombre.trim() });
    setEditId(null);
    await loadEmpresas();
  };

  return (
    <>
      <SettingCard
        icon={I.Building}
        title="Empresas del cuadro de mando"
        sub="Selecciona qué empresas del ERP se visualizan en el CMI. Puedes fusionar varias empresas en una entrada."
        actions={
          <button onClick={() => setShowModal(true)}
            style={{
              display: "flex", alignItems: "center", gap: 6,
              padding: "7px 16px", borderRadius: 8, border: 0, cursor: "pointer",
              background: "var(--ce-primary)", color: "#fff", fontSize: 13, fontWeight: 600,
            }}>
            <I.Plus size={14} /> Agregar
          </button>
        }
      >
        {loading ? (
          <div style={{ textAlign: "center", padding: 24, color: "var(--ce-fg-muted)" }}>Cargando…</div>
        ) : empresas.length === 0 ? (
          <div style={{ textAlign: "center", padding: 32, color: "var(--ce-fg-muted)" }}>
            <I.Building size={32} />
            <p style={{ marginTop: 8, fontSize: 13 }}>No hay empresas configuradas. Pulsa "Agregar" para empezar.</p>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
            {empresas.map((emp, idx) => (
              <div key={emp.id}
                style={{
                  display: "flex", alignItems: "center", gap: 14, padding: "14px 0",
                  borderBottom: idx < empresas.length - 1 ? "1px solid var(--ce-border-subtle)" : "none",
                }}>
                <div style={{
                  width: 38, height: 38, borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center",
                  background: "var(--ce-primary-soft)", color: "var(--ce-primary-ink)", fontWeight: 700, fontSize: 14,
                  flexShrink: 0,
                }}>
                  {emp.nombre.charAt(0).toUpperCase()}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  {editId === emp.id ? (
                    <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                      <input value={editNombre} onChange={e => setEditNombre(e.target.value)}
                        onKeyDown={e => e.key === "Enter" && handleRename(emp.id)}
                        autoFocus
                        style={{
                          flex: 1, padding: "4px 8px", borderRadius: 6,
                          border: "1px solid var(--ce-border)", background: "var(--ce-bg)",
                          color: "var(--ce-fg)", fontSize: 14, fontFamily: "var(--ce-font-sans)",
                        }} />
                      <button onClick={() => handleRename(emp.id)}
                        style={{ background: "none", border: 0, cursor: "pointer", color: "var(--ce-success)", padding: 4 }}>
                        <I.Check size={16} />
                      </button>
                      <button onClick={() => setEditId(null)}
                        style={{ background: "none", border: 0, cursor: "pointer", color: "var(--ce-fg-muted)", padding: 4 }}>
                        <I.X size={16} />
                      </button>
                    </div>
                  ) : (
                    <>
                      <div style={{ fontSize: 14, fontWeight: 600, color: "var(--ce-fg)" }}>{emp.nombre}</div>
                      <div style={{ fontSize: 11, color: "var(--ce-fg-faint)", marginTop: 2 }}>
                        ERP: {emp.empresas_erp_ids.join(", ")}
                        {emp.empresas_erp_ids.length > 1 && <Badge tone="info" style={{ marginLeft: 6, fontSize: 10 }}>Compuesta</Badge>}
                        {emp.holded_api_key && <span style={{ marginLeft: 8 }}>· Holded ✓</span>}
                      </div>
                    </>
                  )}
                </div>
                <div style={{ display: "flex", gap: 4, flexShrink: 0 }}>
                  <button onClick={() => { setEditId(emp.id); setEditNombre(emp.nombre); }}
                    title="Renombrar"
                    style={{ background: "none", border: 0, cursor: "pointer", color: "var(--ce-fg-muted)", padding: 6 }}>
                    <I.Pencil size={14} />
                  </button>
                  <button onClick={() => handleDelete(emp.id, emp.nombre)}
                    title="Eliminar"
                    style={{ background: "none", border: 0, cursor: "pointer", color: "var(--ce-danger)", padding: 6 }}>
                    <I.Trash size={14} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </SettingCard>

      {showModal && (
        <ModalAgregarEmpresa
          onClose={() => setShowModal(false)}
          onSave={handleSave}
        />
      )}
    </>
  );
};

/* ══════════════════════════════
   Sección: Conexiones (existente)
   ══════════════════════════════ */
const SectionConexiones = () => (
  <>
    <SettingCard icon={I.Plug} title="Holded" sub="Integración con Holded por empresa para tesorería, gastos y facturación.">
      {[
        { empresa: "Visados (id 13)",   ok: true },
        { empresa: "Permiso (id 12)",   ok: true },
        { empresa: "CVS (id 14)",       ok: true },
      ].map((r, i) => (
        <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0", borderBottom: i < 2 ? "1px solid var(--ce-border-subtle)" : "none" }}>
          <span style={{ fontSize: 13, color: "var(--ce-fg)" }}>{r.empresa}</span>
          {r.ok
            ? <Badge tone="pos">Conectado</Badge>
            : <Badge tone="warn">Sin API key</Badge>}
        </div>
      ))}
    </SettingCard>

    <SettingCard icon={I.Search} title="Google Search Console" sub="Métricas de tráfico orgánico. Configurado por dominio de empresa.">
      {[
        { empresa: "Visados", site: "sc-domain:visadosempresas.com",   ok: true },
        { empresa: "Permiso", site: "sc-domain:permisodetrabajo.eu",     ok: true },
        { empresa: "CVS",     site: "sc-domain:corporatevisasolutions.com", ok: true },
      ].map((r, i) => (
        <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0", borderBottom: i < 2 ? "1px solid var(--ce-border-subtle)" : "none" }}>
          <div>
            <div style={{ fontSize: 13, color: "var(--ce-fg)" }}>{r.empresa}</div>
            <div style={{ fontSize: 11, color: "var(--ce-fg-faint)", fontFamily: "var(--ce-font-mono)" }}>{r.site}</div>
          </div>
          {r.ok ? <Badge tone="pos">Activo</Badge> : <Badge tone="warn">No configurado</Badge>}
        </div>
      ))}
    </SettingCard>

    <SettingCard icon={I.Bank} title="ERP / Base de datos" sub="Lectura directa del ERP de proyectos y leads.">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <div style={{ fontSize: 13, color: "var(--ce-fg)" }}>erpvisados_2023</div>
          <div style={{ fontSize: 11, color: "var(--ce-fg-faint)", fontFamily: "var(--ce-font-mono)" }}>mysql://·····@51.91.31.191:3306</div>
        </div>
        <Badge tone="pos">Conectado</Badge>
      </div>
    </SettingCard>
  </>
);

/* ══════════════════════════════
   Sección: Perfil
   ══════════════════════════════ */
const SectionPerfil = () => {
  const user = (() => {
    try { return JSON.parse(sessionStorage.getItem("authUser"))?.user || null; } catch { return null; }
  })();
  return (
    <SettingCard icon={I.User} title="Perfil" sub="Información de la cuenta activa.">
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <div><span style={{ fontSize: 11, color: "var(--ce-fg-muted)", display: "block", marginBottom: 4 }}>NOMBRE</span><span style={{ fontSize: 14, color: "var(--ce-fg)" }}>{user?.nombre || "—"}</span></div>
        <div><span style={{ fontSize: 11, color: "var(--ce-fg-muted)", display: "block", marginBottom: 4 }}>EMAIL</span><span style={{ fontSize: 14, color: "var(--ce-fg)", fontFamily: "var(--ce-font-mono)" }}>{user?.email || "—"}</span></div>
        <div><span style={{ fontSize: 11, color: "var(--ce-fg-muted)", display: "block", marginBottom: 4 }}>EMPRESA POR DEFECTO</span><span style={{ fontSize: 14, color: "var(--ce-fg)" }}>ID {user?.empresa_id ?? "—"}</span></div>
      </div>
    </SettingCard>
  );
};

/* ══════════════════════════════
   Sección: Cuentas contables
   ══════════════════════════════ */
const AREA_COLORS = {
  INGRESOS: "#10B981", GASTOS: "#EF4444", COSTES: "#F59E0B",
  PRODUCCION: "#2A5BFF", ESTRUCTURA: "#8B5CF6", MARKETING: "#EC4899",
};

const SectionCuentas = () => {
  const [empresas, setEmpresas] = useState([]);
  const [empresaId, setEmpresaId] = useState(null);
  const [cuentas, setCuentas] = useState([]);
  const [arbol, setArbol] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState("todas");
  const [busqueda, setBusqueda] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [editArea, setEditArea] = useState("");
  const [editCat, setEditCat] = useState("");
  const [editSubcat, setEditSubcat] = useState("");
  const [editNat, setEditNat] = useState("gasto");
  const [editTipoCoste, setEditTipoCoste] = useState("");
  const [editImputable, setEditImputable] = useState(false);
  const [saving, setSaving] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [syncResult, setSyncResult] = useState(null);

  useEffect(() => {
    getCmiEmpresas().then(data => {
      const list = Array.isArray(data) ? data : [];
      setEmpresas(list);
      if (list.length > 0 && !empresaId) setEmpresaId(list[0].empresas_erp_ids[0]);
    }).catch(() => {});
    getCategoriasCuentas().then(data => {
      setArbol(data.arbol || []);
    }).catch(() => {});
  }, []);

  const loadCuentas = useCallback(async () => {
    if (!empresaId) return;
    setLoading(true);
    try {
      const data = await getCuentasContables(empresaId);
      setCuentas(Array.isArray(data) ? data : []);
    } catch (e) { console.error(e); }
    setLoading(false);
  }, [empresaId]);

  useEffect(() => { loadCuentas(); }, [loadCuentas]);

  const handleSync = async () => {
    if (!empresaId) return;
    setSyncing(true);
    setSyncResult(null);
    try {
      const result = await syncCuentasHolded(empresaId, new Date().getFullYear());
      setSyncResult(result);
      await loadCuentas();
    } catch (e) {
      console.error(e);
      setSyncResult({ error: true });
    }
    setSyncing(false);
  };

  const areas = [...new Set(arbol.map(r => r.area))];
  const catsForArea = arbol.filter(r => r.area === editArea);
  const cats = [...new Set(catsForArea.map(r => r.categoria_pyg))];
  const subsForCat = arbol.filter(r => r.area === editArea && r.categoria_pyg === editCat);
  const subs = [...new Set(subsForCat.map(r => r.subcategoria_pyg))];

  const startEdit = (c) => {
    setEditingId(c.id);
    setEditArea(c.area || "");
    setEditCat(c.categoria_pyg || "");
    setEditSubcat(c.subcategoria_pyg || "");
    setEditNat(c.naturaleza || "gasto");
    setEditTipoCoste(c.tipo_coste || "");
    setEditImputable(!!c.imputable_proyecto);
  };

  const cancelEdit = () => setEditingId(null);

  const saveClasificacion = async (cuenta) => {
    if (!editArea || !editCat || !editSubcat) return;
    setSaving(true);
    try {
      await clasificarCuenta({
        empresa_id: empresaId,
        numero_cuenta: cuenta.numero_cuenta,
        area: editArea,
        categoria_pyg: editCat,
        subcategoria_pyg: editSubcat,
        naturaleza: editNat,
        tipo_coste: editTipoCoste || null,
        imputable_proyecto: editImputable,
      });
      setEditingId(null);
      await loadCuentas();
      getCategoriasCuentas().then(data => setArbol(data.arbol || [])).catch(() => {});
    } catch (e) { console.error(e); }
    setSaving(false);
  };

  const handleDesclasificar = async (cuenta) => {
    if (!window.confirm("¿Quitar la clasificación de esta cuenta?")) return;
    await desclasificarCuenta(empresaId, cuenta.numero_cuenta);
    await loadCuentas();
  };

  const filtered = cuentas.filter(c => {
    if (filtro === "sin_clasificar" && c.area) return false;
    if (filtro === "clasificadas" && !c.area) return false;
    if (filtro !== "todas" && filtro !== "sin_clasificar" && filtro !== "clasificadas" && c.area !== filtro) return false;
    if (busqueda) {
      const q = busqueda.toLowerCase();
      return c.numero_cuenta.toLowerCase().includes(q) || (c.denominacion || "").toLowerCase().includes(q);
    }
    return true;
  });

  const totalCuentas = cuentas.length;
  const clasificadas = cuentas.filter(c => c.area).length;
  const sinClasificar = totalCuentas - clasificadas;

  const lastSync = cuentas.length > 0
    ? cuentas.reduce((latest, c) => {
        if (!c.fecha_sync) return latest;
        const d = new Date(c.fecha_sync);
        return d > latest ? d : latest;
      }, new Date(0))
    : null;

  const empresaOptions = [];
  for (const emp of empresas) {
    for (const erpId of emp.empresas_erp_ids) {
      empresaOptions.push({ id: erpId, label: `${emp.nombre} (${erpId})` });
    }
  }

  const selectStyle = {
    padding: "6px 12px", borderRadius: 8, border: "1px solid var(--ce-border)",
    background: "var(--ce-bg)", color: "var(--ce-fg)", fontSize: 13, fontFamily: "var(--ce-font-sans)",
  };

  return (
    <SettingCard
      icon={I.FileText}
      title="Cuentas contables"
      sub="Cuentas sincronizadas desde Holded y su clasificación analítica (Área > Categoría > Subcategoría)."
      actions={
        <select value={empresaId || ""} onChange={e => { setEmpresaId(parseInt(e.target.value)); setSyncResult(null); }} style={selectStyle}>
          {empresaOptions.map(o => <option key={o.id} value={o.id}>{o.label}</option>)}
        </select>
      }
    >
      {/* Barra de sync */}
      <div style={{
        display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap",
        padding: "12px 16px", marginBottom: 16,
        background: "var(--ce-bg-2)", borderRadius: 10, border: "1px solid var(--ce-border-subtle)",
      }}>
        <I.Refresh size={16} style={{ color: "var(--ce-fg-muted)", flexShrink: 0 }} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 13, color: "var(--ce-fg)" }}>Sincronización con Holded</div>
          <div style={{ fontSize: 11, color: "var(--ce-fg-muted)", marginTop: 2 }}>
            {lastSync && lastSync.getTime() > 0
              ? `Última sync: ${lastSync.toLocaleDateString("es-ES")} ${lastSync.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" })}`
              : "Nunca sincronizado"}
            {totalCuentas > 0 && ` · ${totalCuentas} cuentas`}
          </div>
        </div>
        {syncResult && !syncResult.error && (
          <Badge tone="pos">+{syncResult.inserted} nuevas · {syncResult.updated} actualizadas</Badge>
        )}
        {syncResult?.error && <Badge tone="neg">Error al sincronizar</Badge>}
        <button onClick={handleSync} disabled={syncing}
          style={{
            display: "flex", alignItems: "center", gap: 6,
            padding: "7px 16px", borderRadius: 8, border: 0, cursor: syncing ? "wait" : "pointer",
            background: "var(--ce-primary)", color: "#fff", fontSize: 13, fontWeight: 600,
            opacity: syncing ? 0.7 : 1, flexShrink: 0,
          }}>
          <I.Refresh size={14} style={syncing ? { animation: "spin 1s linear infinite" } : {}} />
          {syncing ? "Sincronizando…" : "Sincronizar"}
        </button>
      </div>

      {/* Resumen + filtros */}
      <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap", marginBottom: 16 }}>
        <Badge tone={sinClasificar > 0 ? "warn" : "pos"}>
          {clasificadas}/{totalCuentas} clasificadas
        </Badge>
        {sinClasificar > 0 && <Badge tone="warn">{sinClasificar} sin clasificar</Badge>}
        <div style={{ flex: 1 }} />
        <select value={filtro} onChange={e => setFiltro(e.target.value)} style={selectStyle}>
          <option value="todas">Todas</option>
          <option value="sin_clasificar">Sin clasificar</option>
          <option value="clasificadas">Clasificadas</option>
          {areas.map(a => <option key={a} value={a}>{a}</option>)}
        </select>
        <input value={busqueda} onChange={e => setBusqueda(e.target.value)} placeholder="Buscar cuenta o nombre…" style={{ ...selectStyle, width: 200 }} />
      </div>

      {loading ? (
        <div style={{ textAlign: "center", padding: 24, color: "var(--ce-fg-muted)" }}>Cargando…</div>
      ) : totalCuentas === 0 ? (
        <div style={{ textAlign: "center", padding: 32, color: "var(--ce-fg-muted)" }}>
          <I.FileText size={32} />
          <p style={{ marginTop: 8, fontSize: 13 }}>No hay cuentas sincronizadas. Pulsa "Sincronizar" para importar el plan contable desde Holded.</p>
        </div>
      ) : filtered.length === 0 ? (
        <div style={{ textAlign: "center", padding: 24, color: "var(--ce-fg-muted)", fontSize: 13 }}>No se encontraron cuentas con ese filtro.</div>
      ) : (
        <div style={{ maxHeight: 520, overflow: "auto", border: "1px solid var(--ce-border)", borderRadius: 10 }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr style={{ background: "var(--ce-bg-2)", position: "sticky", top: 0, zIndex: 1 }}>
                <th style={thStyle}>Cuenta</th>
                <th style={thStyle}>Denominación</th>
                <th style={thStyle}>Área</th>
                <th style={thStyle}>Categoría</th>
                <th style={thStyle}>Subcategoría</th>
                <th style={{ ...thStyle, width: 50, textAlign: "center" }}>Nat.</th>
                <th style={{ ...thStyle, width: 50, textAlign: "center" }}>Tipo</th>
                <th style={{ ...thStyle, width: 40, textAlign: "center" }}>Imp.</th>
                <th style={{ ...thStyle, width: 80, textAlign: "center" }}>Acción</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(c => {
                const isEditing = editingId === c.id;
                const areaColor = AREA_COLORS[c.area] || "var(--ce-fg-muted)";
                return (
                  <tr key={c.id} style={{ borderBottom: "1px solid var(--ce-border-subtle)", background: !c.area ? "rgba(245,158,11,0.04)" : "transparent" }}>
                    <td style={tdStyle}>
                      <span style={{ fontFamily: "var(--ce-font-mono)", fontWeight: 600 }}>{c.numero_cuenta}</span>
                    </td>
                    <td style={{ ...tdStyle, color: "var(--ce-fg-2)", maxWidth: 180, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {c.denominacion || "—"}
                    </td>
                    {isEditing ? (
                      <>
                        <td style={tdStyle}>
                          <select value={editArea} onChange={e => { setEditArea(e.target.value); setEditCat(""); setEditSubcat(""); setEditNat(e.target.value === "INGRESOS" ? "ingreso" : "gasto"); }}
                            style={{ ...selectStyle, fontSize: 11, padding: "3px 6px", width: "100%" }}>
                            <option value="">— Área —</option>
                            {areas.map(a => <option key={a} value={a}>{a}</option>)}
                          </select>
                        </td>
                        <td style={tdStyle}>
                          <select value={editCat} onChange={e => { setEditCat(e.target.value); setEditSubcat(""); }}
                            disabled={!editArea}
                            style={{ ...selectStyle, fontSize: 11, padding: "3px 6px", width: "100%" }}>
                            <option value="">— Categoría —</option>
                            {cats.map(c => <option key={c} value={c}>{c}</option>)}
                          </select>
                        </td>
                        <td style={tdStyle}>
                          <select value={editSubcat} onChange={e => setEditSubcat(e.target.value)}
                            disabled={!editCat}
                            style={{ ...selectStyle, fontSize: 11, padding: "3px 6px", width: "100%" }}>
                            <option value="">— Subcategoría —</option>
                            {subs.map(s => <option key={s} value={s}>{s}</option>)}
                          </select>
                        </td>
                        <td style={{ ...tdStyle, textAlign: "center" }}>
                          <select value={editNat} onChange={e => setEditNat(e.target.value)} style={{ ...selectStyle, fontSize: 10, padding: "2px 4px" }}>
                            <option value="gasto">G</option>
                            <option value="ingreso">I</option>
                          </select>
                        </td>
                        <td style={{ ...tdStyle, textAlign: "center" }}>
                          <select value={editTipoCoste} onChange={e => setEditTipoCoste(e.target.value)} style={{ ...selectStyle, fontSize: 10, padding: "2px 4px" }}>
                            <option value="">—</option>
                            <option value="fijo">F</option>
                            <option value="variable">V</option>
                          </select>
                        </td>
                        <td style={{ ...tdStyle, textAlign: "center" }}>
                          <input type="checkbox" checked={editImputable} onChange={e => setEditImputable(e.target.checked)} style={{ accentColor: "var(--ce-primary)" }} />
                        </td>
                        <td style={{ ...tdStyle, textAlign: "center" }}>
                          <div style={{ display: "flex", gap: 4, justifyContent: "center" }}>
                            <button onClick={() => saveClasificacion(c)} disabled={saving || !editArea || !editCat || !editSubcat}
                              style={{ background: "none", border: 0, cursor: "pointer", color: "var(--ce-success)", padding: 4 }}>
                              <I.Check size={16} />
                            </button>
                            <button onClick={cancelEdit}
                              style={{ background: "none", border: 0, cursor: "pointer", color: "var(--ce-fg-muted)", padding: 4 }}>
                              <I.X size={16} />
                            </button>
                          </div>
                        </td>
                      </>
                    ) : (
                      <>
                        <td style={tdStyle}>
                          {c.area ? (
                            <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                              <span style={{ width: 8, height: 8, borderRadius: 4, background: areaColor, flexShrink: 0 }} />
                              {c.area}
                            </span>
                          ) : <span style={{ color: "var(--ce-fg-faint)" }}>—</span>}
                        </td>
                        <td style={{ ...tdStyle, color: "var(--ce-fg-2)" }}>{c.categoria_pyg || "—"}</td>
                        <td style={{ ...tdStyle, color: "var(--ce-fg-2)" }}>{c.subcategoria_pyg || "—"}</td>
                        <td style={{ ...tdStyle, textAlign: "center" }}>
                          {c.naturaleza ? (
                            <Badge tone={c.naturaleza === "ingreso" ? "pos" : "warn"} style={{ fontSize: 10 }}>
                              {c.naturaleza === "ingreso" ? "I" : "G"}
                            </Badge>
                          ) : <span style={{ color: "var(--ce-fg-faint)" }}>—</span>}
                        </td>
                        <td style={{ ...tdStyle, textAlign: "center", fontSize: 11, color: "var(--ce-fg-muted)" }}>
                          {c.tipo_coste === "fijo" ? "F" : c.tipo_coste === "variable" ? "V" : "—"}
                        </td>
                        <td style={{ ...tdStyle, textAlign: "center", color: c.imputable_proyecto ? "var(--ce-primary)" : "var(--ce-fg-faint)" }}>
                          {c.imputable_proyecto ? "✓" : "—"}
                        </td>
                        <td style={{ ...tdStyle, textAlign: "center" }}>
                          <div style={{ display: "flex", gap: 4, justifyContent: "center" }}>
                            <button onClick={() => startEdit(c)} title="Clasificar"
                              style={{ background: "none", border: 0, cursor: "pointer", color: "var(--ce-fg-muted)", padding: 4 }}>
                              <I.Pencil size={14} />
                            </button>
                            {c.area && (
                              <button onClick={() => handleDesclasificar(c)} title="Quitar clasificación"
                                style={{ background: "none", border: 0, cursor: "pointer", color: "var(--ce-danger)", padding: 4 }}>
                                <I.Trash size={14} />
                              </button>
                            )}
                          </div>
                        </td>
                      </>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      <div style={{ marginTop: 10, fontSize: 11, color: "var(--ce-fg-faint)" }}>
        Nat. = Naturaleza (I=Ingreso, G=Gasto) · Tipo = Tipo coste (F=Fijo, V=Variable) · Imp. = Imputable a proyecto
      </div>
    </SettingCard>
  );
};

const thStyle = { padding: "8px 10px", textAlign: "left", fontSize: 11, fontWeight: 600, color: "var(--ce-fg-muted)", borderBottom: "1px solid var(--ce-border)" };
const tdStyle = { padding: "7px 10px", fontSize: 13, color: "var(--ce-fg)" };

/* ══════════════════════════════
   Sección: Presupuestos
   ══════════════════════════════ */
const ESTADO_BADGE = { borrador: "warn", aprobado: "pos", cerrado: "neutral" };
const ESTADO_LABEL = { borrador: "Borrador", aprobado: "Aprobado", cerrado: "Cerrado" };
const SectionPresupuestos = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const [ejercicio, setEjercicio] = useState(currentYear);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(null);
  const [showForm, setShowForm] = useState(null);
  const [fechaInicio, setFechaInicio] = useState(new Date().toISOString().slice(0, 10));
  const [copiarDe, setCopiarDe] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const result = await getPresupuestosPorEmpresa(ejercicio);
      setData(Array.isArray(result) ? result : []);
    } catch (e) { console.error(e); }
    setLoading(false);
  }, [ejercicio]);

  useEffect(() => { load(); }, [load]);

  const openForm = (emp) => {
    setShowForm(emp);
    setFechaInicio(new Date().toISOString().slice(0, 10));
    const prev = emp.presupuestos.find(p => p.activo) || emp.presupuestos[0];
    setCopiarDe(prev ? String(prev.id) : "");
  };

  const handleCrear = async () => {
    if (!showForm) return;
    setCreating(showForm.cmi_empresa_id);
    try {
      const body = { cmi_empresa_id: showForm.cmi_empresa_id, ejercicio, fecha_inicio: fechaInicio };
      if (copiarDe) body.copiar_de = parseInt(copiarDe);
      const result = await createPresupuesto(body);
      setShowForm(null);
      await load();
      if (result?.id) navigate(`/presupuesto/${result.id}`);
    } catch (e) { console.error(e); }
    setCreating(null);
  };

  const years = [];
  for (let y = currentYear + 1; y >= currentYear - 3; y--) years.push(y);

  const inputStyle = {
    padding: "7px 10px", borderRadius: 6, border: "1px solid var(--ce-border)",
    background: "var(--ce-bg)", color: "var(--ce-fg)", fontSize: 13, width: "100%",
  };

  return (
    <SettingCard
      icon={I.Coin}
      title="Presupuestos por empresa"
      sub="Define el presupuesto mensual fijo por empresa. Vigente desde la fecha de inicio hasta que se cree uno nuevo."
      actions={
        <select
          value={ejercicio}
          onChange={e => setEjercicio(parseInt(e.target.value))}
          style={{
            padding: "6px 12px", borderRadius: 8,
            border: "1px solid var(--ce-border)", background: "var(--ce-bg)",
            color: "var(--ce-fg)", fontSize: 13, fontFamily: "var(--ce-font-sans)",
          }}
        >
          {years.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
      }
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: 24, color: "var(--ce-fg-muted)" }}>Cargando…</div>
      ) : data.length === 0 ? (
        <div style={{ textAlign: "center", padding: 32, color: "var(--ce-fg-muted)" }}>
          <I.Coin size={32} />
          <p style={{ marginTop: 8, fontSize: 13 }}>No hay empresas configuradas. Agrega empresas primero en la sección Empresas.</p>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
          {data.map((emp, idx) => {
            const hasPres = emp.presupuestos.length > 0;
            const activePres = emp.presupuestos.find(p => p.activo) || emp.presupuestos[0];
            const fechaFmt = activePres?.fecha_inicio
              ? new Date(activePres.fecha_inicio).toLocaleDateString("es-ES", { day: "numeric", month: "short", year: "numeric" })
              : null;
            return (
              <div key={emp.cmi_empresa_id}
                style={{
                  display: "flex", alignItems: "center", gap: 14, padding: "14px 0",
                  borderBottom: idx < data.length - 1 ? "1px solid var(--ce-border-subtle)" : "none",
                }}>
                <div style={{
                  width: 38, height: 38, borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center",
                  background: "var(--ce-primary-soft)", color: "var(--ce-primary-ink)", fontWeight: 700, fontSize: 14,
                  flexShrink: 0,
                }}>
                  {emp.empresa_nombre.charAt(0).toUpperCase()}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: "var(--ce-fg)" }}>{emp.empresa_nombre}</div>
                  {hasPres ? (
                    <div style={{ fontSize: 11, color: "var(--ce-fg-faint)", marginTop: 2, display: "flex", alignItems: "center", gap: 6 }}>
                      {activePres.nombre}
                      {" · v"}{activePres.version}
                      {fechaFmt && <span>· desde {fechaFmt}</span>}
                      <Badge tone={ESTADO_BADGE[activePres.estado] || "neutral"}>{ESTADO_LABEL[activePres.estado] || activePres.estado}</Badge>
                    </div>
                  ) : (
                    <div style={{ fontSize: 11, color: "var(--ce-fg-faint)", marginTop: 2 }}>
                      Sin presupuesto para {ejercicio}
                    </div>
                  )}
                </div>
                <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
                  {hasPres && (
                    <button
                      onClick={() => navigate(`/presupuesto/${activePres.id}`)}
                      style={{
                        display: "flex", alignItems: "center", gap: 6,
                        padding: "7px 16px", borderRadius: 8, border: 0, cursor: "pointer",
                        background: "var(--ce-bg-2)", color: "var(--ce-fg)",
                        fontSize: 13, fontWeight: 600,
                      }}
                    >
                      <I.Pencil size={14} /> Editar
                    </button>
                  )}
                  <button
                    onClick={() => openForm(emp)}
                    style={{
                      display: "flex", alignItems: "center", gap: 6,
                      padding: "7px 16px", borderRadius: 8, border: 0, cursor: "pointer",
                      background: "var(--ce-primary)", color: "#fff",
                      fontSize: 13, fontWeight: 600,
                    }}
                  >
                    <I.Plus size={14} /> Nuevo
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {showForm && (
        <div style={{ marginTop: 16, padding: 16, border: "1px solid var(--ce-border)", borderRadius: 10, background: "var(--ce-bg)" }}>
          <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 12 }}>
            Nuevo presupuesto — {showForm.empresa_nombre}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <div>
              <label style={{ fontSize: 11, color: "var(--ce-fg-muted)", marginBottom: 4, display: "block" }}>Fecha de inicio</label>
              <input type="date" value={fechaInicio} onChange={e => setFechaInicio(e.target.value)} style={inputStyle} />
            </div>
            <div>
              <label style={{ fontSize: 11, color: "var(--ce-fg-muted)", marginBottom: 4, display: "block" }}>Copiar valores de</label>
              <select value={copiarDe} onChange={e => setCopiarDe(e.target.value)} style={inputStyle}>
                <option value="">— Empezar vacío —</option>
                {showForm.presupuestos.map(p => (
                  <option key={p.id} value={p.id}>{p.nombre} (v{p.version})</option>
                ))}
              </select>
            </div>
          </div>
          <div style={{ display: "flex", gap: 8, marginTop: 14, justifyContent: "flex-end" }}>
            <button onClick={() => setShowForm(null)} style={{ padding: "7px 16px", borderRadius: 8, border: "1px solid var(--ce-border)", background: "var(--ce-bg)", color: "var(--ce-fg)", fontSize: 13, cursor: "pointer" }}>
              Cancelar
            </button>
            <button onClick={handleCrear} disabled={creating} style={{ padding: "7px 20px", borderRadius: 8, border: 0, background: "var(--ce-primary)", color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
              {creating ? "Creando…" : "Crear presupuesto"}
            </button>
          </div>
        </div>
      )}
    </SettingCard>
  );
};

/* ══════════════════════════════
   Sección: Empleados (Kronaly ↔ ERP)
   ══════════════════════════════ */
// ─── Benchmarks sectoriales ───
const BENCHMARK_KPIS = [
  { codigo: "PRODUCCION_TOTAL_INGRESOS", label: "Producción / Ingresos", unidad: "%" },
  { codigo: "GROWTH_INGRESOS", label: "Growth (Ventas + Marketing) / Ingresos", unidad: "%" },
  { codigo: "CORPORATE_SUPPORT_INGRESOS", label: "Corporate Support / Ingresos", unidad: "%" },
  { codigo: "INGRESOS_FTE", label: "Ingreso por empleado", unidad: "€" },
  { codigo: "INGRESOS_FTE_PRODUCTIVO", label: "Ingreso por empleado de Producción", unidad: "€" },
  { codigo: "COSTE_PRODUCCION_FTE_PRODUCTIVO", label: "Coste Producción por empleado Prod.", unidad: "€" },
];

const SectionBenchmarks = () => {
  const [ejercicio, setEjercicio] = useState(new Date().getFullYear());
  const [valores, setValores] = useState({});
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);

  const load = useCallback(async () => {
    try {
      const data = await getBenchmarks(ejercicio);
      const map = {};
      (data || []).forEach(r => { map[r.codigo] = parseFloat(r.valor_referencia) || ""; });
      setValores(map);
    } catch { setValores({}); }
  }, [ejercicio]);

  useEffect(() => { load(); }, [load]);

  const handleChange = (codigo, val) => {
    setValores(prev => ({ ...prev, [codigo]: val }));
    setMsg(null);
  };

  const handleSave = async () => {
    setSaving(true);
    setMsg(null);
    try {
      const benchmarks = BENCHMARK_KPIS.map(k => ({
        codigo: k.codigo,
        valor_referencia: parseFloat(valores[k.codigo]) || 0,
      }));
      await saveBenchmarks(ejercicio, benchmarks);
      setMsg("Benchmarks guardados correctamente");
    } catch (e) {
      setMsg("Error al guardar: " + (e.message || "desconocido"));
    }
    setSaving(false);
  };

  const years = [];
  for (let y = new Date().getFullYear() + 1; y >= 2024; y--) years.push(y);

  return (
    <SettingCard
      icon={I.Target}
      title="Benchmarks sectoriales"
      sub="Valores de referencia del sector para la comparativa anual de KPIs estructurales"
      actions={
        <select value={ejercicio} onChange={e => setEjercicio(parseInt(e.target.value))}
          style={{ padding: "6px 10px", borderRadius: 6, border: "1px solid var(--ce-border)", fontSize: 13, background: "var(--ce-bg)" }}>
          {years.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
      }
    >
      <table className="tbl" style={{ width: "100%", fontSize: 13 }}>
        <thead>
          <tr>
            <th style={{ textAlign: "left", width: "55%" }}>KPI</th>
            <th style={{ textAlign: "left" }}>Valor de referencia</th>
            <th style={{ textAlign: "center", width: 60 }}>Unidad</th>
          </tr>
        </thead>
        <tbody>
          {BENCHMARK_KPIS.map(k => (
            <tr key={k.codigo}>
              <td style={{ color: "var(--ce-fg-muted)" }}>{k.label}</td>
              <td>
                <input
                  type="number" step={k.unidad === "%" ? "0.1" : "1000"}
                  value={valores[k.codigo] ?? ""}
                  onChange={e => handleChange(k.codigo, e.target.value)}
                  style={{ width: 140, padding: "5px 8px", borderRadius: 6, border: "1px solid var(--ce-border)", fontSize: 13, background: "var(--ce-bg)" }}
                />
              </td>
              <td style={{ textAlign: "center", color: "var(--ce-fg-faint)" }}>{k.unidad}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 16 }}>
        <button onClick={handleSave} disabled={saving}
          style={{ padding: "8px 20px", borderRadius: 8, border: "none", background: "var(--ce-primary)", color: "#fff", fontWeight: 600, fontSize: 13, cursor: "pointer", opacity: saving ? 0.6 : 1 }}>
          {saving ? "Guardando…" : "Guardar benchmarks"}
        </button>
        {msg && <span style={{ fontSize: 12, color: msg.startsWith("Error") ? "var(--ce-danger)" : "var(--ce-success)" }}>{msg}</span>}
      </div>
    </SettingCard>
  );
};

const AREAS = ["PRODUCCION", "VENTAS", "MARKETING", "CORPORATE"];
const AREA_LABELS = { PRODUCCION: "Producción", VENTAS: "Ventas", MARKETING: "Marketing", CORPORATE: "Corporate Support" };

const SectionEmpleados = () => {
  const [empresas, setEmpresas] = useState([]);
  const [empresaId, setEmpresaId] = useState(null);
  const [vinculados, setVinculados] = useState([]);
  const [kronalyData, setKronalyData] = useState(null);
  const [usuariosErp, setUsuariosErp] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);
  const [vincForm, setVincForm] = useState({});
  const [catForm, setCatForm] = useState({ nombre: "", descripcion: "" });
  const [editCatId, setEditCatId] = useState(null);

  useEffect(() => {
    getCmiEmpresas().then(data => {
      const list = Array.isArray(data) ? data : [];
      setEmpresas(list);
      if (list.length > 0 && !empresaId) setEmpresaId(list[0].empresas_erp_ids[0]);
    }).catch(() => {});
    getUsuariosErp().then(setUsuariosErp).catch(() => {});
    getCategoriasEmpleados().then(setCategorias).catch(() => {});
  }, []);

  const loadVinculados = useCallback(async () => {
    if (!empresaId) return;
    try { setVinculados(await getEmpleados(empresaId)); } catch { setVinculados([]); }
  }, [empresaId]);

  const loadKronaly = useCallback(async () => {
    if (!empresaId) return;
    setLoading(true);
    try {
      const data = await getKronalyEmpleados(empresaId);
      setKronalyData(data);
      if (data?.employees) {
        setVincForm(prev => {
          const next = { ...prev };
          for (const ke of data.employees) {
            if (!ke.ya_vinculado && ke.erp_match && !next[ke.kronaly_id]?.usuario_id) {
              next[ke.kronaly_id] = { ...next[ke.kronaly_id], usuario_id: String(ke.erp_match.usuario_id) };
            }
          }
          return next;
        });
      }
    } catch { setKronalyData(null); }
    setLoading(false);
  }, [empresaId]);

  useEffect(() => { loadVinculados(); loadKronaly(); }, [empresaId, loadVinculados, loadKronaly]);

  const vinculadosErpIds = new Set(vinculados.map(v => v.erp_user_id).filter(Boolean));

  const handleVincular = async (ke) => {
    const opts = vincForm[ke.kronaly_id] || {};
    if (!opts.usuario_id) { setMsg({ ok: false, text: `Selecciona un usuario del ERP para ${ke.nombre}` }); return; }
    if (!opts.area) { setMsg({ ok: false, text: `Selecciona un área para ${ke.nombre}` }); return; }
    setMsg(null);
    try {
      await vincularEmpleado({
        empresa_id: empresaId,
        erp_user_id: Number(opts.usuario_id),
        kronaly_employee_id: ke.kronaly_id,
        area: opts.area,
        fte: Number(opts.fte) || 1,
        categoria_empleado: opts.categoria_id ? Number(opts.categoria_id) : null,
        is_hof: !!opts.is_hof,
        fecha_desde: `${new Date().getFullYear()}-01-01`,
      });
      setMsg({ ok: true, text: `${ke.nombre} vinculado correctamente` });
      loadKronaly(); loadVinculados();
    } catch { setMsg({ ok: false, text: "Error al vincular" }); }
  };

  const handleToggle = async (empId) => {
    try { await toggleEmpleado(empId); loadVinculados(); } catch { setMsg({ ok: false, text: "Error" }); }
  };

  const handleDelete = async (empId) => {
    if (!window.confirm("¿Eliminar este empleado?")) return;
    try { await deleteEmpleado(empId); loadKronaly(); loadVinculados(); setMsg({ ok: true, text: "Empleado eliminado" }); } catch { setMsg({ ok: false, text: "Error" }); }
  };

  const handleSaveCat = async () => {
    if (!catForm.nombre) return;
    try {
      await saveCategoriasEmpleados({ id: editCatId || undefined, nombre: catForm.nombre, descripcion: catForm.descripcion });
      setCatForm({ nombre: "", descripcion: "" }); setEditCatId(null);
      const cats = await getCategoriasEmpleados(); setCategorias(cats);
    } catch { setMsg({ ok: false, text: "Error al guardar categoría" }); }
  };

  const updateVF = (kid, field, value) => setVincForm(prev => ({ ...prev, [kid]: { ...prev[kid], [field]: value } }));

  const pendientes = kronalyData?.employees?.filter(e => !e.ya_vinculado && e.status === "active") || [];

  const empresaOptions = [];
  for (const emp of empresas) {
    for (const erpId of emp.empresas_erp_ids) {
      empresaOptions.push({ id: erpId, label: `${emp.nombre} (${erpId})` });
    }
  }

  const selectStyle = {
    padding: "6px 12px", borderRadius: 8, border: "1px solid var(--ce-border)",
    background: "var(--ce-bg)", color: "var(--ce-fg)", fontSize: 13,
  };

  return (
    <>
      {msg && <div style={{ padding: "10px 14px", borderRadius: 8, fontSize: 13, marginBottom: 16, background: msg.ok ? "var(--ce-bg-success, #efd)" : "var(--ce-bg-danger, #fee)", color: msg.ok ? "var(--ce-fg-success, #060)" : "var(--ce-fg-danger, #c00)" }}>{msg.text}</div>}

      {/* Selector de empresa */}
      <div style={{ marginBottom: 16 }}>
        <select value={empresaId || ""} onChange={e => { setEmpresaId(parseInt(e.target.value)); setVincForm({}); }} style={selectStyle}>
          {empresaOptions.map(o => <option key={o.id} value={o.id}>{o.label}</option>)}
        </select>
      </div>

      {/* Empleados vinculados */}
      <SettingCard icon={I.Check} title="Empleados vinculados" sub="Empleados asignados a esta empresa con su área, FTE y categoría.">
        {vinculados.length === 0 ? (
          <div style={{ textAlign: "center", padding: 24, color: "var(--ce-fg-muted)", fontSize: 13 }}>Sin empleados vinculados. Usa la lista de Kronaly abajo para vincular.</div>
        ) : (
          <div style={{ maxHeight: 400, overflow: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
              <thead>
                <tr style={{ background: "var(--ce-bg-2)", position: "sticky", top: 0 }}>
                  <th style={thStyle}>Activo</th>
                  <th style={thStyle}>Empleado</th>
                  <th style={thStyle}>Email</th>
                  <th style={thStyle}>Área</th>
                  <th style={thStyle}>FTE</th>
                  <th style={thStyle}>Categoría</th>
                  <th style={thStyle}>HoF</th>
                  <th style={thStyle}></th>
                </tr>
              </thead>
              <tbody>
                {vinculados.map(r => (
                  <tr key={r.id} style={r.activo ? {} : { opacity: 0.5 }}>
                    <td style={tdStyle}><input type="checkbox" checked={!!r.activo} onChange={() => handleToggle(r.id)} /></td>
                    <td style={tdStyle}>{r.empleado_nombre || `ERP #${r.erp_user_id}`}</td>
                    <td style={{ ...tdStyle, fontSize: 12, color: "var(--ce-fg-muted)" }}>{r.email || "—"}</td>
                    <td style={tdStyle}><Badge tone="neu">{AREA_LABELS[r.area] || r.area}</Badge></td>
                    <td style={tdStyle}>{parseFloat(r.fte).toFixed(2)}</td>
                    <td style={tdStyle}>{r.categoria_nombre || "—"}</td>
                    <td style={tdStyle}>{r.is_hof ? <Badge tone="info">HoF</Badge> : "—"}</td>
                    <td style={{ ...tdStyle, textAlign: "right" }}>
                      <button onClick={() => handleDelete(r.id)} style={{ background: "none", border: 0, cursor: "pointer", color: "var(--ce-danger)", padding: 4 }}><I.Trash size={14} /></button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </SettingCard>

      {/* Empleados de Kronaly pendientes */}
      <SettingCard icon={I.UserPlus} title="Empleados en Kronaly" sub="Empleados activos en Kronaly que aún no están vinculados.">
        {loading ? (
          <div style={{ padding: 20, color: "var(--ce-fg-muted)", fontSize: 13 }}>Cargando empleados de Kronaly...</div>
        ) : kronalyData && !kronalyData.configured ? (
          <div style={{ textAlign: "center", padding: 24, color: "var(--ce-fg-muted)", fontSize: 13 }}>Kronaly no configurado para esta empresa.</div>
        ) : pendientes.length === 0 ? (
          <div style={{ textAlign: "center", padding: 24, color: "var(--ce-fg-muted)", fontSize: 13 }}>Todos los empleados activos ya están vinculados.</div>
        ) : (
          <div style={{ maxHeight: 500, overflow: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
              <thead>
                <tr style={{ background: "var(--ce-bg-2)", position: "sticky", top: 0 }}>
                  <th style={thStyle}>Empleado</th>
                  <th style={thStyle}>Email</th>
                  <th style={thStyle}>Cargo</th>
                  <th style={thStyle}>Usuario ERP</th>
                  <th style={thStyle}>Área</th>
                  <th style={thStyle}>FTE</th>
                  <th style={thStyle}>Categoría</th>
                  <th style={thStyle}>HoF</th>
                  <th style={thStyle}></th>
                </tr>
              </thead>
              <tbody>
                {pendientes.map(ke => {
                  const opts = vincForm[ke.kronaly_id] || {};
                  return (
                    <tr key={ke.kronaly_id}>
                      <td style={tdStyle}>{ke.nombre}</td>
                      <td style={{ ...tdStyle, fontSize: 12 }}>{ke.email || "—"}</td>
                      <td style={{ ...tdStyle, fontSize: 12, color: "var(--ce-fg-muted)" }}>{ke.position || "—"}</td>
                      <td style={tdStyle}>
                        <select style={{ ...selectStyle, fontSize: 12, padding: "4px 8px", minWidth: 160 }}
                          value={opts.usuario_id || ""} onChange={e => updateVF(ke.kronaly_id, "usuario_id", e.target.value)}>
                          <option value="">— Seleccionar —</option>
                          {usuariosErp.filter(u => !vinculadosErpIds.has(u.id) || String(u.id) === opts.usuario_id)
                            .map(u => <option key={u.id} value={u.id}>{u.nombres} {u.apellidos || ""} ({u.email || "—"})</option>)}
                        </select>
                        {ke.erp_match && opts.usuario_id === String(ke.erp_match.usuario_id) && (
                          <div style={{ fontSize: 10, color: "var(--ce-fg-success, #060)", marginTop: 2 }}>Auto-match</div>
                        )}
                      </td>
                      <td style={tdStyle}>
                        <select style={{ ...selectStyle, fontSize: 12, padding: "4px 8px", minWidth: 110 }}
                          value={opts.area || ""} onChange={e => updateVF(ke.kronaly_id, "area", e.target.value)}>
                          <option value="">— Área —</option>
                          {AREAS.map(a => <option key={a} value={a}>{AREA_LABELS[a]}</option>)}
                        </select>
                      </td>
                      <td style={tdStyle}>
                        <input type="number" step="0.25" min="0" max="1" style={{ ...selectStyle, width: 60, fontSize: 12, padding: "4px 6px" }}
                          value={opts.fte ?? "1"} onChange={e => updateVF(ke.kronaly_id, "fte", e.target.value)} />
                      </td>
                      <td style={tdStyle}>
                        <select style={{ ...selectStyle, fontSize: 12, padding: "4px 8px", minWidth: 100 }}
                          value={opts.categoria_id || ""} onChange={e => updateVF(ke.kronaly_id, "categoria_id", e.target.value)}>
                          <option value="">— Categoría —</option>
                          {categorias.map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
                        </select>
                      </td>
                      <td style={tdStyle}>
                        <input type="checkbox" checked={!!opts.is_hof} onChange={e => updateVF(ke.kronaly_id, "is_hof", e.target.checked)} />
                      </td>
                      <td style={{ ...tdStyle, textAlign: "right" }}>
                        <button onClick={() => handleVincular(ke)}
                          style={{ padding: "4px 12px", fontSize: 12, fontWeight: 600, border: "none", borderRadius: 6, background: "var(--ce-bg-success, #efd)", color: "var(--ce-fg-success, #060)", cursor: "pointer" }}>
                          Vincular
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </SettingCard>

      {/* Categorías de empleados */}
      <SettingCard icon={I.Tag} title="Categorías de empleados" sub="Categorías profesionales para clasificar empleados.">
        <div style={{ display: "flex", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
          <div style={{ flex: 1, minWidth: 150 }}>
            <input style={{ ...selectStyle, width: "100%" }} placeholder="Nombre de la categoría" value={catForm.nombre} onChange={e => setCatForm({ ...catForm, nombre: e.target.value })} />
          </div>
          <div style={{ flex: 1, minWidth: 150 }}>
            <input style={{ ...selectStyle, width: "100%" }} placeholder="Descripción (opcional)" value={catForm.descripcion} onChange={e => setCatForm({ ...catForm, descripcion: e.target.value })} />
          </div>
          <button onClick={handleSaveCat} style={{ padding: "6px 16px", fontSize: 13, fontWeight: 600, border: "none", borderRadius: 8, background: "var(--ce-primary)", color: "#fff", cursor: "pointer" }}>
            {editCatId ? "Actualizar" : "Añadir"}
          </button>
        </div>
        {categorias.length > 0 && (
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr><th style={thStyle}>Nombre</th><th style={thStyle}>Descripción</th><th style={thStyle}></th></tr>
            </thead>
            <tbody>
              {categorias.map(c => (
                <tr key={c.id}>
                  <td style={tdStyle}>{c.nombre}</td>
                  <td style={{ ...tdStyle, color: "var(--ce-fg-muted)" }}>{c.descripcion || "—"}</td>
                  <td style={{ ...tdStyle, textAlign: "right" }}>
                    <button onClick={() => { setEditCatId(c.id); setCatForm({ nombre: c.nombre, descripcion: c.descripcion || "" }); }}
                      style={{ background: "none", border: 0, cursor: "pointer", color: "var(--ce-fg-muted)", padding: 4 }}>
                      <I.Pencil size={14} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </SettingCard>
    </>
  );
};

/* ══════════════════════════════
   Página principal
   ══════════════════════════════ */
const DashboardConfig = () => {
  document.title = "Configuración | CMI";
  const [searchParams] = useSearchParams();
  const [active, setActive] = useState(searchParams.get("section") || "empresas");

  return (
    <>
      <PageHead icon={I.Settings} title="Configuración" sub="Empresas · conexiones · cuenta · preferencias" />

      <div className="grid" style={{ gridTemplateColumns: "240px 1fr", gap: 24, alignItems: "start" }}>
        <nav style={{ position: "sticky", top: 84, display: "flex", flexDirection: "column", gap: 2, background: "var(--ce-surface)", border: "1px solid var(--ce-border)", borderRadius: 14, padding: 8, boxShadow: "var(--ce-shadow-md)" }}>
          {sections.map((s) => {
            const Ico = s.icon;
            const isActive = active === s.id;
            return (
              <button key={s.id} onClick={() => setActive(s.id)}
                style={{
                  display: "flex", alignItems: "center", gap: 10,
                  padding: "0 12px", height: 38, borderRadius: 10,
                  border: 0, cursor: "pointer", textAlign: "left",
                  background: isActive ? "var(--ce-primary-soft)" : "transparent",
                  color: isActive ? "var(--ce-primary-ink)" : "var(--ce-fg-2)",
                  fontFamily: "var(--ce-font-sans)", fontSize: 13, fontWeight: isActive ? 600 : 500,
                  transition: "background 120ms var(--ce-ease)",
                }}>
                <Ico size={16} />
                {s.label}
              </button>
            );
          })}
        </nav>

        <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
          {active === "empresas" && <SectionEmpresas />}
          {active === "empleados" && <SectionEmpleados />}
          {active === "cuentas"  && <SectionCuentas />}
          {active === "presup"   && <SectionPresupuestos />}
          {active === "bench"    && <SectionBenchmarks />}
          {active === "conex"    && <SectionConexiones />}
          {active === "perfil"   && <SectionPerfil />}
          {active === "cuenta"   && <Placeholder title="Cuenta y seguridad" />}
          {active === "notif"    && <Placeholder title="Notificaciones" />}
          {active === "prefs"    && <Placeholder title="Preferencias" />}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default DashboardConfig;
